module.exports = __webpack_public_path__ + "img/vote_example_wxcode.bd15efd9.jpg";